import { IAppState } from '../../redux';
import { EHomeownerType } from '../../redux/reducers';

export const selectIsHomeowner = (state: IAppState): boolean => {
  return state.user.homeownerInfo?.userType === EHomeownerType.homeowner;
};
